"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getPackageBaseUrl_1 = require("owa-session-store/lib/actions/getPackageBaseUrl");
var url_1 = require("url");
var owa_analytics_1 = require("owa-analytics");
var InHouseAdTargetUrl = 'https://w2.outlook.com/l/upsell?WT.mc_id=PROD_OL-Web_InApp_NativeAd_Upgrade';
function generateDefaultOutlookAds(plannedMessageAdType, adMarket, isOneClick, triggerEvent) {
    var loadDefaultNativeAdsDataPoint = new owa_analytics_1.PerformanceDatapoint('LoadDefaultOutlookNativeAds');
    loadDefaultNativeAdsDataPoint.addCustomData({
        messageAdType: "OutlookUpSell" /* OutlookUpSell */,
        userMarket: adMarket,
        originalMessageAdType: plannedMessageAdType,
        refreshEvent: triggerEvent,
    });
    var result = [];
    var defaultMessageAd = {
        adId: null,
        adSender: null,
        adSubject: null,
        adPreviewTexts: null,
        adTextsAboveImage: null,
        adTextsOnImage: null,
        adCallToActionTextsOnImage: null,
        adCallToActionTextsBelowImage: null,
        adTextsToRenderBody: null,
        adImageUrl: url_1.resolve(getPackageBaseUrl_1.default(), 'resources/images/ads-olk-inhouse-readingpane.png'),
        adImageTargetUrl: InHouseAdTargetUrl,
        adFavIconurl: url_1.resolve(getPackageBaseUrl_1.default(), 'resources/images/ads-olk-icon.png'),
        adImpressionUrl: null,
        adType: "OutlookUpSell" /* OutlookUpSell */,
        adOneClickDirectTargetUrl: isOneClick ? InHouseAdTargetUrl : null,
        adClickTrackers: null,
        adChoiceUrl: 'https://choice.microsoft.com',
        adMarket: adMarket,
        adRefreshEvent: triggerEvent,
        isRead: false,
    };
    result.push(defaultMessageAd);
    loadDefaultNativeAdsDataPoint.end();
    return result;
}
exports.default = generateDefaultOutlookAds;
//# sourceMappingURL=generateDefaultOutlookAds.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-messagead-orchestration/lib/services/generateDefaultOutlookAds.js
// module id = 6017
// module chunks = 67